module.exports = __webpack_public_path__ + "static/media/dumy-recent-news-3.e789c52a.png";